﻿
<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-tabs">
    <div class="dsk-tab dsk-pulse" *ngFor="let t of [1,2,3,4,5]"></div>
  </div>
  <div class="dsk-panel">
    <div class="dsk-panel-head">
      <div class="dsk-cell dsk-pulse" style="width:140px;height:14px"></div>
      <div class="dsk-spacer"></div>
      <div class="dsk-btn dsk-pulse"></div>
    </div>
    <div class="dsk-panel-body" style="gap:20px;padding:22px 24px">
      <div style="display:flex;align-items:center;gap:16px;padding:14px;background:#faf8ff;border-radius:10px;border:1px solid #ece9e6">
        <div class="dsk-avatar dsk-pulse" style="width:72px;height:72px;border-radius:12px"></div>
        <div style="display:flex;flex-direction:column;gap:8px;flex:1">
          <div class="dsk-cell dsk-pulse" style="width:120px;height:14px"></div>
          <div class="dsk-cell dsk-pulse" style="width:200px;height:11px"></div>
          <div class="dsk-btn-sm dsk-pulse" style="width:100px;height:32px;margin-top:4px"></div>
        </div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px" *ngFor="let r of [1,2,3]">
        <div style="display:flex;flex-direction:column;gap:7px">
          <div class="dsk-cell dsk-pulse" style="width:90px;height:11px"></div>
          <div class="dsk-cell dsk-pulse" style="height:38px;border-radius:8px"></div>
        </div>
        <div style="display:flex;flex-direction:column;gap:7px">
          <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
          <div class="dsk-cell dsk-pulse" style="height:38px;border-radius:8px"></div>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;gap:7px">
        <div class="dsk-cell dsk-pulse" style="width:100px;height:11px"></div>
        <div class="dsk-cell dsk-pulse" style="height:80px;border-radius:8px"></div>
      </div>
    </div>
  </div>
</div>

<div class="st-page" *ngIf="!loading">

  <div class="st-readonly-banner" *ngIf="!canEdit">
    <mat-icon>info_outline</mat-icon>
    <span>You have read-only access. Contact your admin to make changes.</span>
  </div>

  <div class="st-toolbar">
  <div class="st-tab-bar">
    <button class="st-tab" [class.st-tab--active]="activeTab === 'company'" (click)="activeTab = 'company'">
      <mat-icon>business</mat-icon>
      <span>Company Profile</span>
    </button>
    <button class="st-tab" [class.st-tab--active]="activeTab === 'brand'" (click)="activeTab = 'brand'">
      <mat-icon>palette</mat-icon>
      <span>Brand Identity</span>
    </button>
    <button class="st-tab" [class.st-tab--active]="activeTab === 'security'" (click)="activeTab = 'security'">
      <mat-icon>lock_outline</mat-icon>
      <span>Security</span>
    </button>
    <button class="st-tab" [class.st-tab--active]="activeTab === 'geolocation'" (click)="activeTab = 'geolocation'" *ngIf="canEdit">
      <mat-icon>location_on</mat-icon>
      <span>Localization</span>
    </button>
    <button class="st-tab" [class.st-tab--active]="activeTab === 'demo'" (click)="activeTab = 'demo'; loadDemoStatus()" *ngIf="canEdit">
      <mat-icon>data_object</mat-icon>
      <span>Demo Data</span>
    </button>
  </div>

    <div class="st-header-actions">
      <button class="st-save-btn" *ngIf="activeTab === 'company' && canEdit" (click)="saveCompany()" [disabled]="saving">
        <mat-icon>save</mat-icon> {{ saving ? 'Saving…' : 'Save Changes' }}
      </button>
      <button class="st-save-btn" *ngIf="activeTab === 'geolocation' && canEdit" (click)="saveGeolocationSettings()" [disabled]="geoSaving">
        <mat-icon>save</mat-icon> {{ geoSaving ? 'Saving…' : 'Save Changes' }}
      </button>
    </div>
  </div>

  <div class="st-content" *ngIf="activeTab === 'company'">

    <div class="st-card">
      <div class="st-logo-row">
        <div class="st-logo-preview">
          <img *ngIf="logoPreview" [src]="logoPreview" class="st-logo-img" alt="Logo">
          <mat-icon *ngIf="!logoPreview" class="st-logo-placeholder-icon">add_a_photo</mat-icon>
        </div>
        <div class="st-logo-body">
          <div class="st-logo-title">Company Logo</div>
          <div class="st-logo-hint">Upload your organization's primary logo. This will appear on all official documents, invoices, and the employee portal. PNG, JPG up to 2MB recommended.</div>
          <div class="st-logo-actions" *ngIf="canEdit">
            <input type="file" accept="image/*" #logoInput hidden (change)="onLogoSelected($event)">
            <button class="st-btn st-btn-outline" (click)="logoInput.click()">
              <mat-icon>cloud_upload</mat-icon> {{ logoPreview ? 'Change Logo' : 'Upload Logo' }}
            </button>
            <button class="st-btn st-btn-danger" *ngIf="logoPreview" (click)="removeLogo()">
              <mat-icon>delete_outline</mat-icon> Remove
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="st-card">
      <div class="st-card-title">General Information</div>
      <div class="st-grid">
        <div class="st-field">
          <label class="st-label">COMPANY NAME</label>
          <input class="st-input" [(ngModel)]="company.companyName" placeholder="CyberNxt Global Solutions" [readonly]="!canEdit">
        </div>
        <div class="st-field">
          <label class="st-label">LEGAL NAME</label>
          <input class="st-input" [(ngModel)]="company.legalName" placeholder="CyberNxt Pvt. Ltd." [readonly]="!canEdit">
        </div>
        <div class="st-field">
          <label class="st-label">INDUSTRY</label>
          <select class="st-input st-select" [(ngModel)]="company.industry" [disabled]="!canEdit">
            <option value="">Select Industry</option>
            <option>Information Technology</option>
            <option>Finance & Banking</option>
            <option>Healthcare</option>
            <option>Manufacturing</option>
            <option>Retail</option>
            <option>Education</option>
            <option>Other</option>
          </select>
        </div>
        <div class="st-field">
          <label class="st-label">COMPANY SIZE</label>
          <select class="st-input st-select" [(ngModel)]="company.companySize" [disabled]="!canEdit">
            <option value="">Select Size</option>
            <option>1–“10 Employees</option>
            <option>11–“50 Employees</option>
            <option>51–“250 Employees</option>
            <option>251–“1000 Employees</option>
            <option>1000+ Employees</option>
          </select>
        </div>
      </div>
    </div>

    <div class="st-card">
      <div class="st-card-title">
        Regulatory Details
        <span class="st-card-title-badge">
          <mat-icon>verified_user</mat-icon>
        </span>
      </div>
      <div class="st-grid">
        <div class="st-field">
          <label class="st-label">CIN NUMBER</label>
          <input class="st-input" [(ngModel)]="company.cinNumber" placeholder="Corporate Identity Number" [readonly]="!canEdit">
        </div>
        <div class="st-field">
          <label class="st-label">GST NUMBER</label>
          <input class="st-input" [(ngModel)]="company.gstNumber" placeholder="e.g. 22AAAAA0000A1Z5" [readonly]="!canEdit">
        </div>
        <div class="st-field">
          <label class="st-label">PAN NUMBER</label>
          <input class="st-input" [(ngModel)]="company.panNumber" placeholder="e.g. ABCDE1234F" [readonly]="!canEdit">
        </div>
        <div class="st-field">
          <label class="st-label">COMPANY WEBSITE</label>
          <input class="st-input" [(ngModel)]="company.website" placeholder="https://cybernxt.com" [readonly]="!canEdit">
        </div>
      </div>
    </div>

    <div class="st-card">
      <div class="st-card-title">Contact Information</div>
      <div class="st-grid">
        <div class="st-field">
          <label class="st-label">SUPPORT EMAIL</label>
          <input class="st-input" [(ngModel)]="company.supportEmail" placeholder="hr@cybernxt.com" [readonly]="!canEdit">
        </div>
        <div class="st-field">
          <label class="st-label">PHONE NUMBER</label>
          <input class="st-input" [(ngModel)]="company.phoneNumber" placeholder="+1 (555) 012–“3456" [readonly]="!canEdit">
        </div>
        <div class="st-field st-field-full">
          <label class="st-label">REGISTERED ADDRESS</label>
          <textarea class="st-input st-textarea" [(ngModel)]="company.registeredAddress" rows="3"
            placeholder="1200 Innovation Drive, Suite 400, Tech Plaza East, San Francisco, CA 94105, United States"
            [readonly]="!canEdit"></textarea>
        </div>
      </div>
    </div>

    <div class="st-bottom-actions" *ngIf="canEdit">
      <button class="st-confirm-btn" (click)="saveCompany()" [disabled]="saving">
        <mat-icon>save</mat-icon>
        {{ saving ? 'Saving…' : 'Confirm Changes' }}
      </button>
    </div>

  </div>

  <div class="st-content" *ngIf="activeTab === 'brand'">
    <div class="st-card">
      <div class="st-card-title">Display Preferences</div>
      <div class="st-toggle-list">
        <div class="st-toggle-row">
          <div class="st-toggle-info">
            <div class="st-toggle-label">Dark Mode</div>
            <div class="st-toggle-desc">Switch between light and dark themes</div>
          </div>
          <mat-slide-toggle [(ngModel)]="appearance.darkMode" color="primary" [disabled]="!canEdit"></mat-slide-toggle>
        </div>
        <div class="st-toggle-row">
          <div class="st-toggle-info">
            <div class="st-toggle-label">Compact Mode</div>
            <div class="st-toggle-desc">Reduce spacing for a denser layout</div>
          </div>
          <mat-slide-toggle [(ngModel)]="appearance.compactMode" color="primary" [disabled]="!canEdit"></mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <div class="st-content" *ngIf="activeTab === 'security'">
    <div class="st-card">
      <div class="st-card-title">Security Settings</div>
      <div class="st-toggle-list">
        <div class="st-toggle-row">
          <div class="st-toggle-info">
            <div class="st-toggle-label">Two-Factor Authentication</div>
            <div class="st-toggle-desc">Add an extra layer of security to all accounts</div>
          </div>
          <mat-slide-toggle [(ngModel)]="security.twoFactor" color="primary" [disabled]="!canEdit"></mat-slide-toggle>
        </div>
        <div class="st-toggle-row">
          <div class="st-toggle-info">
            <div class="st-toggle-label">Session Timeout</div>
            <div class="st-toggle-desc">Auto logout users after period of inactivity</div>
          </div>
          <mat-slide-toggle [(ngModel)]="security.sessionTimeout" color="primary" [disabled]="!canEdit"></mat-slide-toggle>
        </div>
        <div class="st-toggle-row">
          <div class="st-toggle-info">
            <div class="st-toggle-label">Session Duration (minutes)</div>
            <div class="st-toggle-desc">Minutes before auto-logout when timeout is enabled</div>
          </div>
          <input class="st-input st-duration-input" type="number" [(ngModel)]="security.sessionDuration" [readonly]="!canEdit">
        </div>
      </div>
    </div>
  </div>

  <div class="st-content" *ngIf="activeTab === 'geolocation'">

    <div class="st-info-banner">
      <mat-icon>info_outline</mat-icon>
      <div>
        <div class="st-info-title">Attendance Geofencing</div>
        <div class="st-info-sub">Configure a geographic boundary for attendance check-in/check-out. Employees must be within the specified radius to mark attendance.</div>
      </div>
    </div>

    <div class="st-card">
      <div class="st-card-title">Geofencing Settings</div>
      <div class="st-toggle-list">
        <div class="st-toggle-row">
          <div class="st-toggle-info">
            <div class="st-toggle-label">Enable Geofencing</div>
            <div class="st-toggle-desc">Require employees to be at a specific location for attendance</div>
          </div>
          <mat-slide-toggle [(ngModel)]="geolocation.enabled" color="primary"></mat-slide-toggle>
        </div>
      </div>

      <div *ngIf="geolocation.enabled" class="st-geo-body">
        <div class="st-detect-banner">
          <mat-icon>my_location</mat-icon>
          <span>Click "Detect Location" to automatically set your current coordinates.</span>
          <button class="st-btn st-btn-outline" (click)="detectCurrentLocation()" [disabled]="detectingLocation">
            <mat-icon>{{ detectingLocation ? 'hourglass_empty' : 'gps_fixed' }}</mat-icon>
            {{ detectingLocation ? 'Detecting…' : 'Detect Location' }}
          </button>
        </div>

        <div class="st-grid">
          <div class="st-field">
            <label class="st-label">LATITUDE</label>
            <input class="st-input" type="number" step="0.000001" [(ngModel)]="geolocation.latitude" placeholder="e.g. 19.076090">
          </div>
          <div class="st-field">
            <label class="st-label">LONGITUDE</label>
            <input class="st-input" type="number" step="0.000001" [(ngModel)]="geolocation.longitude" placeholder="e.g. 72.877426">
          </div>
          <div class="st-field">
            <label class="st-label">ALLOWED RADIUS (meters)</label>
            <input class="st-input" type="number" min="10" max="5000" [(ngModel)]="geolocation.radius" placeholder="100">
          </div>
        </div>

        <div class="st-toggle-list" style="margin-top:16px">
          <div class="st-toggle-row">
            <div class="st-toggle-info">
              <div class="st-toggle-label">Allow Manual Override</div>
              <div class="st-toggle-desc">Permit admins to manually mark attendance if location fails</div>
            </div>
            <mat-slide-toggle [(ngModel)]="geolocation.allowManualOverride" color="primary"></mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>

    <div class="st-bottom-actions" *ngIf="canEdit">
      <button class="st-confirm-btn" (click)="saveGeolocationSettings()" [disabled]="geoSaving">
        <mat-icon>save</mat-icon>
        {{ geoSaving ? 'Saving…' : 'Confirm Changes' }}
      </button>
    </div>

    <div class="zone-section">
      <div class="zone-section-header">
        <div>
          <div class="zone-section-title">Work Zones</div>
          <div class="zone-section-sub">Assign different check-in locations to individual employees, departments, or everyone. Resolution order: Employee › Department › Global.</div>
        </div>
        <button class="zone-add-btn" (click)="openZoneForm()" *ngIf="canEdit">
          <mat-icon>add</mat-icon> Add Zone
        </button>
      </div>

      <div class="zone-loading" *ngIf="zonesLoading">Loading zones…</div>
      <div class="zone-empty" *ngIf="!zonesLoading && zones.length === 0">
        No work zones defined yet. Click "Add Zone" to create one.
      </div>
      <div class="zone-list" *ngIf="!zonesLoading && zones.length > 0">
        <div class="zone-card" *ngFor="let z of zones" [class.zone-disabled]="!z.enabled">
          <div class="zone-card-left">
            <div class="zone-card-name">{{ z.name }}</div>
            <div class="zone-card-meta">
              <span class="zone-badge" [class.badge-global]="z.scopeType==='global'" [class.badge-dept]="z.scopeType==='department'" [class.badge-emp]="z.scopeType==='employee'">
                {{ z.scopeType === 'global' ? 'Global' : z.scopeType === 'department' ? 'Dept' : 'Employee' }}
              </span>
              <span class="zone-scope-label">{{ getScopeLabel(z) }}</span>
              <span class="zone-coords">{{ z.latitude?.toFixed(4) }}, {{ z.longitude?.toFixed(4) }}</span>
              <span class="zone-radius">{{ z.radiusMeters }}m</span>
            </div>
            <div class="zone-address" *ngIf="z.address">ðŸ“ {{ z.address }}</div>
          </div>
          <div class="zone-card-actions" *ngIf="canEdit">
            <mat-slide-toggle [checked]="z.enabled" (change)="toggleZone(z)" color="primary" title="Enable/disable zone"></mat-slide-toggle>
            <button class="zone-edit-btn" (click)="openZoneForm(z)"><mat-icon>edit</mat-icon></button>
            <button class="zone-del-btn" (click)="deleteZone(z.id)"><mat-icon>delete</mat-icon></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showZoneForm" (click)="closeZoneForm()">
    <div class="zone-modal" (click)="$event.stopPropagation()">
      <div class="zone-modal-header">
        <span>{{ editingZoneId ? 'Edit Zone' : 'New Work Zone' }}</span>
        <button class="modal-close" (click)="closeZoneForm()">=</button>
      </div>
      <div class="zone-modal-body">

        <div class="zf-row">
          <label class="zf-label">Zone Name *</label>
          <input class="zf-input" [(ngModel)]="zoneForm.name" placeholder="e.g. HQ Office, Warehouse, Mumbai Branch">
        </div>

        <div class="zf-row zf-row-2">
          <div>
            <label class="zf-label">Latitude *</label>
            <input class="zf-input" type="number" step="0.000001" [(ngModel)]="zoneForm.latitude" placeholder="19.076090">
          </div>
          <div>
            <label class="zf-label">Longitude *</label>
            <input class="zf-input" type="number" step="0.000001" [(ngModel)]="zoneForm.longitude" placeholder="72.877426">
          </div>
        </div>

        <button class="zf-detect-btn" (click)="detectZoneLocation()" [disabled]="detectingZoneLocation">
          <mat-icon>my_location</mat-icon>
          {{ detectingZoneLocation ? 'Detecting…' : 'Use My Current Location' }}
        </button>

        <div class="zf-row">
          <label class="zf-label">Allowed Radius (metres) *</label>
          <input class="zf-input" type="number" min="50" max="10000" [(ngModel)]="zoneForm.radiusMeters" placeholder="200">
          <span class="zf-hint">50 –“ 10,000 m. Employees must check in within this distance.</span>
        </div>

        <div class="zf-row">
          <label class="zf-label">Address (optional)</label>
          <input class="zf-input" [(ngModel)]="zoneForm.address" placeholder="e.g. 123 Main St, Mumbai">
        </div>

        <div class="zf-row">
          <label class="zf-label">Assign To *</label>
          <div class="zf-scope-pills">
            <button class="zf-scope-pill" [class.active]="zoneForm.scopeType==='global'"     (click)="zoneForm.scopeType='global';     zoneForm.scopeId=null">ðŸŒ Everyone</button>
            <button class="zf-scope-pill" [class.active]="zoneForm.scopeType==='department'" (click)="zoneForm.scopeType='department'; zoneForm.scopeId=null">ðŸ¢ Department</button>
            <button class="zf-scope-pill" [class.active]="zoneForm.scopeType==='employee'"   (click)="zoneForm.scopeType='employee';   zoneForm.scopeId=null">ðŸ‘¤ Employee</button>
          </div>
        </div>

        <div class="zf-row" *ngIf="zoneForm.scopeType === 'department'">
          <label class="zf-label">Select Department *</label>
          <select class="zf-input" [(ngModel)]="zoneForm.scopeId">
            <option value="">Choose department</option>
            <option *ngFor="let d of departments" [value]="d.id">{{ d.name }}</option>
          </select>
        </div>

        <div class="zf-row" *ngIf="zoneForm.scopeType === 'employee'">
          <label class="zf-label">Select Employee *</label>
          <select class="zf-input" [(ngModel)]="zoneForm.scopeId">
            <option value="">Choose employee</option>
            <option *ngFor="let e of employees" [value]="e.id">{{ e.firstName }} {{ e.lastName }} ({{ e.employeeId }})</option>
          </select>
        </div>

        <div class="zf-row zf-enabled-row">
          <label class="zf-label">Enabled</label>
          <mat-slide-toggle [(ngModel)]="zoneForm.enabled" color="primary"></mat-slide-toggle>
        </div>

      </div>
      <div class="zone-modal-footer">
        <button class="zf-cancel-btn" (click)="closeZoneForm()">Cancel</button>
        <button class="zf-save-btn" (click)="submitZone()" [disabled]="zoneSubmitting">
          {{ zoneSubmitting ? 'Saving…' : (editingZoneId ? 'Update Zone' : 'Create Zone') }}
        </button>
      </div>
    </div>
  </div>

  <div class="st-content" *ngIf="activeTab === 'demo' && canEdit">
    <div class="st-card">
      <div class="st-card-header">
        <mat-icon>data_object</mat-icon>
        <div>
          <h3 class="st-card-title">Demo Data Management</h3>
          <p class="st-card-desc">Seed or clear sample data for testing and demonstrations. Demo employees, departments, teams, attendance, leaves, payroll and announcements will be created or removed.</p>
        </div>
      </div>

      <div class="demo-status-row" *ngIf="!demoLoading && demoStatus">
        <div class="demo-status-badge" [class.demo-status-badge--seeded]="demoStatus.isSeeded">
          <mat-icon>{{ demoStatus.isSeeded ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
          {{ demoStatus.isSeeded ? 'Demo data is seeded' : 'No demo data present' }}
        </div>
        <div class="demo-counts" *ngIf="demoStatus.isSeeded">
          <span class="demo-count-chip"><b>{{ demoStatus.counts.employees }}</b> employees</span>
          <span class="demo-count-chip"><b>{{ demoStatus.counts.departments }}</b> departments</span>
          <span class="demo-count-chip"><b>{{ demoStatus.counts.teams }}</b> teams</span>
          <span class="demo-count-chip"><b>{{ demoStatus.counts.announcements }}</b> announcements</span>
          <span class="demo-count-chip"><b>{{ demoStatus.counts.clients }}</b> clients</span>
        </div>
      </div>
      <div class="demo-status-row" *ngIf="demoLoading">
        <mat-spinner diameter="20"></mat-spinner>
        <span style="margin-left:10px;color:#64748b">Loading status…</span>
      </div>

      <div class="demo-actions">
        <button class="demo-seed-btn" (click)="seedDemoData()" [disabled]="demoSeeding || demoClearing || (demoStatus?.isSeeded)">
          <mat-icon>add_circle_outline</mat-icon>
          {{ demoSeeding ? 'Seeding…' : 'Seed Demo Data' }}
        </button>
        <button class="demo-clear-btn" (click)="clearDemoData()" [disabled]="demoClearing || demoSeeding || !(demoStatus?.isSeeded)">
          <mat-icon>delete_sweep</mat-icon>
          {{ demoClearing ? 'Clearing…' : 'Clear Demo Data' }}
        </button>
      </div>

      <div class="demo-warning">
        <mat-icon>warning_amber</mat-icon>
        <span>Clearing demo data is irreversible. It will remove all records tagged as demo including employees, attendance, leaves, payroll, and performance data.</span>
      </div>
    </div>
  </div>

</div>

